import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { Box, Button } from '@mui/material';
import { CarModel, StockStatus } from 'models/StockModel';
import useCars from 'modules/cars/hooks/useCars';
import { calcReadiness } from 'modules/cars/utils/common';
import auth from 'recoil/atoms/auth';


type StatusButtonsCardProps = {
    car: CarModel,
}

const StatusButtonsCard = ({car}: StatusButtonsCardProps) => {
    const my = useRecoilValue(auth);
    const {t} = useTranslation('cars');
    const {setStatus} = useCars();

    if (!my.permissions.has('cars manage') || (car.status === StockStatus.Pending && calcReadiness(car) < 100))
        return null;

    return (
        <Box sx={{textAlign: 'right', mb: 2}}>
            {car.status !== StockStatus.Pending && (
                <Box component="span" sx={{mr:2, color: car.status !== StockStatus.Canceled ? 'green' : 'red', textTransform: 'uppercase'}}>{car.status}</Box>
            )}
            {car.status === StockStatus.Pending && calcReadiness(car) === 100 && (
                <Button
                    variant="contained"
                    color="success"
                    onClick={() => setStatus(car.id, StockStatus.Ready)}
                >
                    {t('ready_to_be_shipped')}
                </Button>
            )}

            {car.status === StockStatus.Shipped && (
                <Button
                    variant="contained"
                    color="success"
                    onClick={() => setStatus(car.id, StockStatus.Received)}
                >
                    {t('received_by_consignee')}
                </Button>
            )}
        </Box>
    );
};

export default StatusButtonsCard;
